import { lazy } from 'react';
import { Navigate } from 'react-router';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import userTypes from 'constants/userTypes';
import { isPasswordEnabled } from 'utils/auth';
import { isMobileShellEnabled } from 'services/mobileShell';
import SentryErrorBoundary from '../SentryErrorBoundary';

const ClassicLogin = Loadable(lazy(() => import('views/authentication/auth-components/Login')));
const MobileLogin = Loadable(lazy(() => import('mobile/screens/Login')));
const Redirect = Loadable(lazy(() => import('views/authentication/auth-components/Redirect')));
const RequireLogin = Loadable(lazy(() => import('views/authentication/auth-components/RequireLogin')));
const ForgotPassword = Loadable(lazy(() => import('views/authentication/auth-components/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('views/authentication/auth-components/ResetPassword')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

// Built as a function (not a static object) so the password-dependent routes are evaluated at render time.
// On native the enabled auth methods are not known until a workspace is selected, which happens after this module is imported.
const AuthenticationRoutes = () => {
  const Login = isMobileShellEnabled() ? MobileLogin : ClassicLogin;

  return {
    path: '/',
    element: <MinimalLayout />,
    errorElement: <SentryErrorBoundary />,
    children: [
      {
        path: '/',
        element: <Navigate to="/login" />
      },
      {
        path: '/login',
        element: <Login userType={userTypes.Admin} />
      },
      {
        path: '/login-manager',
        element: <Login userType={userTypes.Manager} />
      },
      {
        path: '/login-ext-user',
        element: <Login userType={userTypes.ExternalUser} />
      },
      {
        path: '/redirect',
        element: <Redirect />
      },
      ...(isPasswordEnabled()
        ? [
            {
              path: '/forgot-password',
              element: <ForgotPassword />
            },
            {
              path: '/reset-password',
              element: <ResetPassword />
            }
          ]
        : []),
      {
        path: '*',
        element: <RequireLogin />
      }
    ]
  };
};

export default AuthenticationRoutes;
